exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".engagement-survey-container{display:flex;flex-direction:column;gap:45px;position:static;padding-block:20px;height:100vh;width:100%;overflow:auto;overflow-x:hidden;background-image:url(/images/error-page-bg.png);background-color:#1d4659;touch-action:manipulation}@media(max-width:992px){.engagement-survey-container{gap:25px;padding-block:10px}}.engagement-survey-container .form-container{display:flex;flex-direction:column;gap:35px;margin:auto}@media(max-width:992px){.engagement-survey-container .form-container{margin:0 auto}}", ""]);

// exports
